import { loadOptions } from '../../versa/formset.js';
import { STATUS_LABELS } from '../utils/input-dock-schedule-labels.js';

/** Opções de filtro — status de agendamento de doca (#MT-B2FA396). */
export default function (...args)
{
	return {
		options: Object.entries(STATUS_LABELS).map(([value, label]) => ({ value, label })),
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		},
	};
}
